import { createStore, StoreOptions } from 'vuex';

import toatsModule from '@/store/modules/toasts';
import userMenuModule from '@/store/modules/userMenu';
import errorModule from '@/store/modules/error';
import routerModule from '@/store/modules/router';
import careerIdModule from '@/store/modules/careerId';
import newsModule from '@/store/modules/news';
import mstMyPageModule from './modules/mstMyPage';
import favoritesModule from './modules/favorites';
import mailSecurityModule from './modules/mailSecurity';
import ordersModule from './modules/orders';

export type RootState = {
  version: string;
};

const store: StoreOptions<RootState> = {
  modules: {
    toasts: toatsModule,
    userMenu: userMenuModule,
    error: errorModule,
    router: routerModule,
    careerId: careerIdModule,
    news: newsModule,
    mstMyPage: mstMyPageModule,
    favorites: favoritesModule,
    mailSecurity: mailSecurityModule,
    orders: ordersModule,
  },
};

export default createStore<RootState>(store);
